const translations = {
  'nav.about': 'О платформе',
  'nav.packages': 'Тарифы',
  'nav.calculator': 'Калькулятор',
  'nav.contacts': 'Контакты',
  'nav.cta': 'Начать инвестировать',

  'hero.badge': 'Сезонный тренд · Весна 2025',
  'hero.title_p1': 'Весенний рост',
  'hero.title_hl': 'кукурузы',
  'hero.title_p2': '— возможность заработать на сезонном тренде',
  'hero.desc': 'Исторически цена на кукурузу растёт весной из-за увеличения спроса со стороны производителей кормов, биоэтанола и подготовки аграрного сезона. Инвесторы используют этот сезонный цикл каждый год.',
  'hero.cta1': 'Рассчитать прибыль сейчас',
  'hero.cta2': 'Смотреть тарифы',
  'hero.stat1.val': '+34%',
  'hero.stat1.label': 'Средний рост весной',
  'hero.stat2.val': '5+ лет',
  'hero.stat2.label': 'Стабильного тренда',
  'hero.stat3.val': 'ТОП-3',
  'hero.stat3.label': 'Мировой с/х актив',
  'hero.scroll': 'прокрутите вниз',
  'hero.chart.title': 'Динамика цены Corn · Весна',
  'hero.chart.subtitle': 'Индексированный рост (Фев = 100%)',
  'hero.chart.maxgrowth': '+38%',
  'hero.chart.maxlabel': 'Максимальный рост за сезон',
  'hero.chart.years': '100%',
  'hero.chart.yearslabel': 'Лет с положительным ростом',
  'hero.months.0': 'Фев',
  'hero.months.1': 'Мар',
  'hero.months.2': 'Апр',
  'hero.months.3': 'Май',

  'price.badge': 'Сезонная аналитика',
  'price.title_p1': 'Почему кукуруза',
  'price.title_hl': 'растёт весной?',
  'price.subtitle': 'Пять ключевых факторов, формирующих устойчивый ценовой тренд каждый год',
  'price.r1.title': 'Спрос от животноводства',
  'price.r1.desc': 'Весной увеличивается спрос на корма со стороны животноводческих предприятий, готовящихся к активному сезону.',
  'price.r1.statLabel': 'рост спроса',
  'price.r2.title': 'Посевная кампания',
  'price.r2.desc': 'Начало активного периода посева создаёт ажиотаж на рынке и давление на доступные запасы.',
  'price.r2.statLabel': 'рост активности',
  'price.r3.title': 'Производители биоэтанола',
  'price.r3.desc': 'Биоэтанольные заводы увеличивают закупки кукурузы для производства топлива в весенний сезон.',
  'price.r3.statLabel': 'рост закупок',
  'price.r4.title': 'Снижение запасов',
  'price.r4.desc': 'К весне прошлогодние запасы сокращаются, что создаёт дефицит предложения и толкает цену вверх.',
  'price.r4.statLabel': 'остатки запасов',
  'price.r5.title': 'Рыночные ожидания',
  'price.r5.desc': 'Рынок закладывает ожидания будущего урожая — неопределённость увеличивает волатильность и потенциал роста.',
  'price.r5.statLabel': 'рост волатильности',
  'price.banner.avg': 'Средний рост за 5 лет',
  'price.banner.desc': 'По статистике прошлых лет весенний сезон является одним из наиболее активных периодов роста цены',
  'price.banner.corn': 'Corn',
  'price.banner.desc2': '.',
  'price.banner.disclaimer': 'Исторические данные CME Group, USDA · не является финансовой рекомендацией',
  'price.banner.years': 'Лет с ростом (5/5)',

  'pkg.badge': 'Инвестиционные контракты',
  'pkg.title_p1': 'Выберите',
  'pkg.title_hl': 'инвестиционный',
  'pkg.title_p2': 'контракт',
  'pkg.subtitle': 'Три уровня участия — от старта до максимальной прибыли',
  'pkg.start.name': 'Контракт Старт',
  'pkg.balance.name': 'Контракт Баланс',
  'pkg.premium.name': 'Контракт Премиум',
  'pkg.seasonal': 'Инвестиции в Corn · 2 дня',
  'pkg.investment': 'Инвестиция',
  'pkg.duration': 'Срок:',
  'pkg.days': 'дня',
  'pkg.yield': 'Доходность',
  'pkg.profit': 'Прибыль:',
  'pkg.cta': 'Начать инвестирование',
  'pkg.popular': 'Популярный',
  'pkg.max': 'Максимум',
  'pkg.disclaimer': '* Все данные о доходности основаны на исторической динамике рынка. Инвестиции сопряжены с рисками.',
  'pkg.f.threshold': 'Входной порог — €{{amount}}',
  'pkg.f.profit': 'Прибыль {{pct}}% за 2 дня',
  'pkg.f.report.monthly': 'Ежемесячный отчёт',
  'pkg.f.report.weekly': 'Еженедельный отчёт',
  'pkg.f.report.daily': 'Ежедневный отчёт',
  'pkg.f.support.reg': 'Поддержка 5/7',
  'pkg.f.support.prio': 'Приоритетная поддержка',
  'pkg.f.support.vip': 'VIP-поддержка 7/7',
  'pkg.f.account': 'Личный кабинет',
  'pkg.f.analytics': 'Аналитика рынка',
  'pkg.f.manager': 'Персональный менеджер',
  'pkg.duration_fixed': 'Фиксированный срок для всех контрактов',

  'calc.badge': 'Калькулятор доходности',
  'calc.title_p1': 'Рассчитайте',
  'calc.title_hl': 'вашу прибыль',
  'calc.subtitle': 'Введите параметры и узнайте ожидаемый доход',
  'calc.params': 'Параметры инвестиции',
  'calc.amount': 'Сумма инвестирования',
  'calc.package': 'Инвестиционный тариф',
  'calc.dur.label': 'Срок инвестирования',
  'calc.dur.val': '2 дня',
  'calc.dur.fixed': 'Фиксированный срок для всех контрактов',
  'calc.result': 'Результат расчёта',
  'calc.expected': 'Ожидаемая прибыль',
  'calc.per2days': '% за 2 дня',
  'calc.total': 'Итоговая сумма',
  'calc.invested': 'Инвестиция',
  'calc.pkg.label': 'Тариф',
  'calc.period': 'Период',
  'calc.period.val': '2 дня',
  'calc.bar.invested': 'Вложено',
  'calc.bar.profit': 'Прибыль',
  'calc.cta': 'Выбрать контракт',

  'activity.header': 'Активность платформы',
  'activity.invested': 'инвестировал',
  'activity.profit': 'получил прибыль',
  'activity.just_now': 'только что',
  'activity.1min': '1 мин. назад',
  'activity.2min': '2 мин. назад',
  'activity.3min': '3 мин. назад',
  'activity.disclaimer': 'демонстрация активности пользователей платформы в режиме реального времени',
  'activity.badge': 'Сообщество инвесторов',
  'activity.title_p1': 'Тысячи инвесторов уже',
  'activity.title_hl': 'зарабатывают вместе с нами',
  'activity.desc': 'Каждый день наши клиенты получают прибыль от сезонного тренда кукурузы. Присоединитесь к тысячам инвесторов, которые используют этот цикл ежегодно.',
  'activity.stat1': 'Активных инвесторов',
  'activity.stat2': 'Средств под управлением',
  'activity.stat3': 'Довольных клиентов',
  'activity.join': 'Присоединиться',
  'activity.view': 'Смотреть тарифы',

  'toast.earned': 'только что заработал',

  'trust.badge': 'Почему нам доверяют',
  'trust.title_p1': 'Надёжность, проверенная',
  'trust.title_hl': 'временем',
  'trust.subtitle': 'Corn — один из самых ликвидных и предсказуемых аграрных активов в мире',
  'trust.item1.title': 'Старейший инструмент торговли',
  'trust.item1.desc': 'Инвестиции в аграрные сырьевые рынки являются одним из старейших инструментов сезонной торговли — проверено столетиями рыночной истории.',
  'trust.item2.title': 'ТОП-3 мировых с/х активов',
  'trust.item2.desc': 'Кукуруза входит в топ-3 мировых сельскохозяйственных активов по объёму торгов и ликвидности на биржах CME и CBOT.',
  'trust.item3.title': 'Повышенная волатильность весной',
  'trust.item3.desc': 'Весенний сезон historically показывает повышенную волатильность и потенциал роста, создавая уникальные возможности для инвесторов.',
  'trust.stat1.label': 'лет истории рынка',
  'trust.stat2.label': 'объём торгов в год',
  'trust.stat3.label': 'среди с/х активов',
  'trust.stat4.label': 'ликвидность позиций',
  'trust.cta.desc': 'Готовы воспользоваться весенним трендом? Рассчитайте потенциальную прибыль прямо сейчас.',
  'trust.cta.btn': 'Рассчитать прибыль сейчас',

  'footer.tagline': '— Сезонные инвестиции в Corn',
  'footer.about': 'О платформе',
  'footer.packages': 'Тарифы',
  'footer.calculator': 'Калькулятор',
  'footer.disclaimer': '© 2025 CornVest. Не является инвестиционной рекомендацией.',
};

export default translations;
